import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqData } from '../data/faqData';
import FAQItem from '../components/FAQItem';
import Button from '../components/styled/Button';

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const [openItems, setOpenItems] = useState(new Set());
  
  const faqs = faqData[i18n.language] || faqData.en;

  const toggleItem = (id) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(id)) {
      newOpenItems.delete(id);
    } else {
      newOpenItems.add(id);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="hemp-bg-gradient py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center p-8 bg-gradient-to-br from-white to-hemp-green-50 rounded-2xl shadow-2xl">
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 tracking-tight drop-shadow-lg">
              {t('faq.title')}
            </h1>
            <p className="text-xl text-gray-800 max-w-3xl mx-auto font-medium bg-white/80 px-4 py-3 rounded-lg">
              {t('faq.subtitle')}
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {faqs.map((faq) => (
              <FAQItem
                key={faq.id}
                question={faq.question}
                answer={faq.answer}
                isOpen={openItems.has(faq.id)}
                onToggle={() => toggleItem(faq.id)}
              />
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-16 text-center">
            <div className="hemp-card">
              <h2 className="text-2xl font-bold text-hemp-green-800 mb-4">
                {t('faq.contact.title')}
              </h2>
              <p className="text-gray-600 mb-6">
                {t('faq.contact.subtitle')}
              </p>
              <Button variant="primary">
                {t('faq.contact.button')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
